export const getHighestDiscountPercentage = (product) => {
  return (
    product?.variants?.reduce((highest, variant) => {
      const discount = Math.round(
        ((variant.compareAtPrice?.amount - variant.price?.amount) * 100) / variant.compareAtPrice?.amount,
      );
      return discount && discount > highest ? discount : highest;
    }, 0) || 0
  );
};

export const isNew = (product) => {
  const launchDateISO = product?.launchDate?.value;

  if (!launchDateISO) {
    return false;
  }

  const now = new Date();
  const launch = new Date(launchDateISO);
  const thirtyDaysAgo = new Date(new Date().setDate(now.getDate() - 30));

  // Product is considered new if it was launched within the last 30 days
  return launch > thirtyDaysAgo;
};

export const getProductBadges = (product) => {
  if (!product) return [];

  const BADGE_LIMIT = 1;
  const tags = product?.tags?.map((tag) => tag.toLowerCase());

  const getBadge = {
    'coming-soon': () =>
      tags.includes('coming soon') && {
        label: 'Coming Soon',
      },

    discount: () => {
      const discount = getHighestDiscountPercentage(product);
      return (
        tags.includes('salemd') &&
        discount > 0 && {
          label: `${discount}% off`,
        }
      );
    },

    new: () =>
      isNew(product) && {
        label: 'New',
      },

    preorder: () =>
      tags.includes('preorder') && {
        label: 'Pre-Order',
      },

    'sold-out': () =>
      !product?.availableForSale && {
        label: 'Sold Out',
      },
  };

  const badgePriority = ['preorder', 'coming-soon', 'sold-out', 'discount', 'new'];

  const allBadges = badgePriority
    .map((badge) => {
      const badgeData = typeof getBadge[badge] === 'function' && getBadge[badge]();
      if (badgeData) {
        badgeData.type = badge;
        return badgeData;
      }
    })
    .filter((badge) => !!badge);

  return allBadges.slice(0, BADGE_LIMIT);
};
